import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { getEleve, getPhoto, updatePaiementEleve, updateSendStatusFacture } from './eleve.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { statutEnvoiFacture } from 'app/shared/model/eleve.model';

export const EleveFactureModal = (props: RouteComponentProps<{ id: string; ecoleid: string; anneeScolaireId: string }>) => {
  const dispatch = useAppDispatch();
  const eleve = useAppSelector(state => state.eleve.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const id_ = props.match.params.id;

  useEffect(() => {
    dispatch(getEleve(props.match.params.id));
    dispatch(getPhoto(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/eleve/${currentEcole && currentEcole.id}/${props.match.params.anneeScolaireId}/${id_}/details`);
  };

  const confirmUpdate = event => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
      statutEnvoiFacture: eleve.statutEnvoiFacture === statutEnvoiFacture.ACTIVE ? 'DESACTIVE' : 'ACTIVE',
    };

    dispatch(updateSendStatusFacture(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      {eleve.id !== null && (
        <Modal
          title="Confirmation de changement du statut d'envoi de facture"
          centered
          footer={[
            <Button key="back" onClick={goBack} style={{ backgroundColor: 'blue', color: 'white' }}>
              Annuler
            </Button>,
            <Button key="submit" style={{ backgroundColor: 'green', color: 'white' }} onClick={confirmUpdate}>
              {eleve.statutEnvoiFacture === statutEnvoiFacture.ACTIVE ? 'Désactiver' : 'Activer'}
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          Etes-vous certain de vouloir {eleve.statutEnvoiFacture === statutEnvoiFacture.ACTIVE ? 'désactiver' : 'activer'} l&apos;envoi de
          facture pour l&apos;élève {eleve.firstName} {eleve.lastName} ?
        </Modal>
      )}
    </>
  );
};

export default EleveFactureModal;
